// sx props for ClientSwitcher component
// Must use sx props to style the TrackableButtons; styles in a module.scss file won't work
// with our TrackableButton (mui).
// Trigger button sx styles
export const triggerButtonSx = {
    all: 'unset',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: 0,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    minWidth: 0,
    '@media screen and (min-width: 960px)': {
        '&:hover [class*="clientNamePill"]': {
            backgroundColor: 'var(--secondary-color-engaged, #170b0133)',
        },
    },
    '&:focus': {
        outline: '2px solid var(--off-black, #170b01)',
        outlineOffset: '4px',
        borderRadius: '4px',
    },
};
// Base client option sx styles
export const getClientOptionSx = (options) => {
    const { isCurrent, isEmployee, disabled } = options;
    const baseSx = {
        all: 'unset',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        padding: '14px 16px',
        border: 'none',
        textAlign: 'left',
        boxSizing: 'border-box',
    };
    if (isCurrent) {
        // Current client (not clickable)
        return {
            ...baseSx,
            backgroundColor: 'var(--secondary-color-engaged, #170b0133)',
            border: '1px solid var(--off-black, #170b01)',
            cursor: 'default',
            // Round top corners when first item to match container's border-radius
            '&:first-child': {
                borderRadius: '7px 7px 0 0',
                '&::before': {
                    borderRadius: '7px 0 0 0',
                },
            },
            '& [class*="clientItemName"]': {
                fontWeight: 700,
            },
            '&:hover': {
                backgroundColor: 'var(--secondary-color-engaged, #170b0133)',
            },
            ...(isEmployee && {
                position: 'relative',
                paddingLeft: '19px',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    left: '1px',
                    top: '1px',
                    bottom: '1px',
                    width: '3px',
                    backgroundColor: 'var(--mint, #abe69e)',
                },
            }),
            ...(disabled && {
                opacity: 0.7,
            }),
        };
    }
    // Selectable client option
    return {
        ...baseSx,
        background: isEmployee ? 'white' : 'none',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background 0.15s ease, opacity 0.15s ease',
        '& [class*="clientItemName"]': {
            fontWeight: 500,
        },
        ...(!disabled && {
            '&:hover': {
                background: 'var(--secondary-color-engaged, #170b0133)',
                '& [class*="clientItemName"]': {
                    fontWeight: 700,
                },
            },
        }),
        ...(isEmployee && {
            position: 'relative',
            paddingLeft: '19px',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '3px',
                backgroundColor: 'var(--mint, #abe69e)',
            },
        }),
        ...(disabled && {
            opacity: 0.7,
        }),
    };
};
// View all workspaces link sx styles
export const viewAllLinkSx = {
    all: 'unset',
    display: 'block',
    width: '100%',
    padding: '14px 16px',
    background: 'none',
    border: 'none',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'var(--off-black, #170b01)',
    transition: 'background 0.15s ease',
    boxSizing: 'border-box',
    '&:hover': {
        background: 'var(--secondary-color-engaged, #170b0133)',
        fontWeight: 700,
    },
};
